// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"443":"about","767":"details","913":"post"}[chunkId] || chunkId) + "." + {"443":"80cf5fef","549":"7cd7fa79","767":"b483fbe6","913":"82bb45db"}[chunkId] + ".css";
};